"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApartmentContext = void 0;
var react_1 = require("react");
exports.ApartmentContext = react_1.createContext({
    activeApartmentId: undefined,
    setActiveApartmentId: function () { },
});
